module.exports = __webpack_public_path__ + "img/t5-12.39a3f2ba.svg";